<template>
    <div>
        <AlertModal :controller="controller.alertModal" ></AlertModal>
        <ConfirmModal :controller="controller.confirmModal"></ConfirmModal>
        <LoadingModal :controller="controller.loadingModal"></LoadingModal>
        <LoadingDeliveryModal :controller="controller.loadingDeliveryModal"></LoadingDeliveryModal>
        <TracesModal :controller="controller.tracesModal"></TracesModal>
        <BadgesModal :controller="controller.badgesModal"></BadgesModal>
        <ConfirmRedeemModal :controller="controller.confirmRedeemModal"></ConfirmRedeemModal>
        <SerialModal :controller="controller.serialModal"></SerialModal>
        <DrawDeliveryModal :controller="controller.drawDeliveryModal"></DrawDeliveryModal>
        <ShippingAddressModal :controller="controller.shippingAddressModal"></ShippingAddressModal>
        <AddAddressModal :controller="controller.addAddressModal"></AddAddressModal>
        <EditAddressModal :controller="controller.editAddressModal"></EditAddressModal>
        <ListAddressModal :controller="controller.listAddressModal"></ListAddressModal>
        <AddTaxAddressModal :controller="controller.addTaxAddressModal"></AddTaxAddressModal>
        <EditTaxAddressModal :controller="controller.editTaxAddressModal"></EditTaxAddressModal>
        <ListTaxAddressModal :controller="controller.listTaxAddressModal"></ListTaxAddressModal>
        <OtpModal :controller="controller.otpModal"></OtpModal>
        <ConfirmCouponModal :controller="controller.confirmCouponModal"></ConfirmCouponModal>
        <ConditionCouponModal :controller="controller.conditionCouponModal"></ConditionCouponModal>
        <UpsaleModal :controller="controller.upsaleModal"></UpsaleModal>
        <ConfirmTwoButtonModal :controller="controller.confirmTwoButtonModal"></ConfirmTwoButtonModal>
        <ConfirmGuestLoginModal :controller="controller.confirmGuestLoginModal"></ConfirmGuestLoginModal>
        <ConfirmResetPasswordModal :controller="controller.confirmResetPasswordModal"></ConfirmResetPasswordModal>
        <SuccessModal :controller="controller.successModal"></SuccessModal>
        <OrderDetailModal :controller="controller.orderDetailModal"></OrderDetailModal>
        <FreeGiftModal :controller="controller.freeGiftModal"></FreeGiftModal>
        <ConfirmRedeemRewardModal :controller="controller.confirmRedeemRewardModal"></ConfirmRedeemRewardModal>
        <ConfirmUseRewardModal :controller="controller.confirmUseRewardModal"></ConfirmUseRewardModal>
        <ErrorModal :controller="controller.errorModal"></ErrorModal>
        <StoreDetailModal :controller="controller.storeDetailModal"></StoreDetailModal>
        <OrderDeliveryDetailModal v-if="controller.orderDeliveryModal != null" :controller="controller.orderDeliveryModal"></OrderDeliveryDetailModal>
        <NotificationModal :controller="controller.notificationModal"></NotificationModal>
        <QRPaymentModal :controller="controller.qrPaymentModal"></QRPaymentModal>
        <ConfirmRedeemSubscriptionModal :controller="controller.confirmRedeemSubscriptionModal"></ConfirmRedeemSubscriptionModal>
        <PdpaModal :controller="controller.pdpaModal"></PdpaModal>
    </div>
</template>
<script>
//generic
import AlertModal from './Generic/AlertModal/AlertModal.vue';
import ConfirmModal from "./Generic/ConfirmModal/ConfirmModal.vue";
import LoadingModal from './Generic/LoadingModal/LoadingModal.vue';
import LoadingDeliveryModal from '@/module/ShoppingCart/modal/LoadingDeliveryModal/LoadingDeliveryModal.vue';
import SuccessModal from './Generic/SuccessModal/SuccessModal.vue';
import ErrorModal from './Generic/ErrorModal/ErrorModal.vue';
//traces and badges
import TracesModal from '@/module/Register/modal/tracesModal/TracesModal.vue';
import BadgesModal from '@/module/Register/modal/badgesModal/BadgesModal.vue';
//redeem
import ConfirmRedeemModal from '@/module/Detail/modal/ConfirmRedeemModal/ConfirmRedeemModal.vue';
import SerialModal from '@/module/Detail/modal/SerialModal/SerialModal.vue';
import DrawDeliveryModal from '@/module/Detail/modal/DrawDeliveryModal/DrawDeliveryModal.vue';
import ShippingAddressModal from '@/module/Detail/modal/ShippingAddressModal/ShippingAddressModal.vue';
import ConfirmRedeemRewardModal from '@/module/Reward/Detail/modal/ConfirmRedeemReward/ConfirmRedeemRewardModal.vue';
import ConfirmUseRewardModal from '@/module/Reward/Detail/modal/ConfirmUseReward/ConfirmUseRewardModal.vue';
import ConfirmRedeemSubscriptionModal from '@/module/Reward/Detail/modal/ConfirmRedeemSubscription/ConfirmRedeemSubscriptionModal.vue';
//address
import AddAddressModal from '@/module/Address/DeliveryAddress/modal/AddAddressModal/AddAddressModal.vue';
import EditAddressModal from '@/module/Address/DeliveryAddress/modal/EditAddressModal/EditAddressModal.vue';
import ListAddressModal from '@/module/Address/DeliveryAddress/modal/ListAddressModal/ListAddressModal.vue';
import AddTaxAddressModal from '@/module/Address/TaxAddress/modal/AddTaxAddressModal/AddTaxAddressModal.vue';
import EditTaxAddressModal from '@/module/Address/TaxAddress/modal/EditTaxAddressModal/EditTaxAddressModal.vue';
import ListTaxAddressModal from '@/module/Address/TaxAddress/modal/ListTaxAddressModal/ListTaxAddressModal.vue';
//Otp
import OtpModal from './Otp/OtpModal.vue';
//Coupon
import ConfirmCouponModal from '@/module/Coupon/modal/ConfirmCouponModal/ConfirmCouponModal.vue';
import ConditionCouponModal from '../../module/Coupon/modal/ConditionCouponModal/ConditionCouponModal.vue'
//Shopping Cart
import UpsaleModal from '@/module/ShoppingCart/modal/UpsaleModal/UpsaleModal.vue';
import ConfirmTwoButtonModal from '@/module/ShoppingCart/modal/ConfirmTwoButtonModal/ConfirmTwoButtonModal.vue'
//login
import ConfirmGuestLoginModal from '@/module/Login/modal/ConfirmGuestLoginModal/ConfirmGuestLoginModal.vue';
import ConfirmResetPasswordModal from '@/module/ResetPassword/modal/ConfirmResetPasswordModal/ConfirmResetPasswordModal.vue';
//Myorder
import OrderDetailModal from '@/module/MyOrder/modal/OrderDetailModal/OrderDetailModal.vue';
import OrderDeliveryDetailModal from "@/module/MyOrder/modal/OrderDeliveryDetailModal/OrderDeliveryDetailModal.vue"
import FreeGiftModal from '@/module/MyOrder/modal/FreeGiftModal/FreeGiftModal.vue';

//Store
import StoreDetailModal from '@/module/Store/modal/StoreDetailModal/StoreDetailModal.vue';
// custom
import NotificationModal from './Notification/NotificationModal.vue';
// payment
import QRPaymentModal from '@/module/ShoppingCart/modal/QRPaymentModal/QRPaymentModal.vue';
//pdpa
import PdpaModal from './Authen/PdpaModal/PdpaModal.vue';

export default {
    name: 'ModalMaster',
    components: {
        AlertModal,
        ConfirmModal,
        LoadingModal,
        LoadingDeliveryModal,
        TracesModal,
        BadgesModal,
        ConfirmRedeemModal,
        SerialModal,
        ShippingAddressModal,
        DrawDeliveryModal,
        AddAddressModal,
        EditAddressModal,
        ListAddressModal,
        AddTaxAddressModal,
        EditTaxAddressModal,
        ListTaxAddressModal,
        OtpModal,
        ConfirmCouponModal,
        ConditionCouponModal,
        UpsaleModal,
        ConfirmTwoButtonModal,
        ConfirmGuestLoginModal,
        ConfirmResetPasswordModal,
        SuccessModal,
        OrderDetailModal,
        FreeGiftModal,
        ConfirmRedeemRewardModal,
        ConfirmUseRewardModal,
        ErrorModal,
        StoreDetailModal,
        OrderDeliveryDetailModal,
        NotificationModal,
        QRPaymentModal,
        ConfirmRedeemSubscriptionModal,
        PdpaModal,
    },
    props: {
        controller: {
            type: Object,
            required: true,
        },
    },
}
</script>
